/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../generated-types/appsync";
type GeneratedSubscription<InputType, OutputType> = string & {
  __generatedSubscriptionInput: InputType;
  __generatedSubscriptionOutput: OutputType;
};

export const tailLogMessages = /* GraphQL */ `subscription TailLogMessages($jobRunId: String!) {
  tailLogMessages(jobRunId: $jobRunId) {
    jobRunId
    messageId
    event
    message
    time
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.TailLogMessagesSubscriptionVariables,
  APITypes.TailLogMessagesSubscription
>;
